import { Window } from '../../00_IMMEDIATE/Window';

export class Window_TaskSlider extends Window {
  /**
   * The window that slides in to display the tasks at the beginning of the level.
   * @param {Object} parent The parent layer to add this window to.
   */
  constructor(parent) {
    super(parent);

    // the window should not fade in/out like a regular window
    // because we're going to slide it in.
    this.NOFADEINOUT = true;

    // start from the top of the game window
    this.y = game.height * -1.5;

    G.sfx.whoosh_short_1.play();

    // setting up layout

    // add bg
    this.addBackground('task_slider');
    this.bg.y = G.l(120);
    
    if (!game.device.desktop) {
      this.bg.scale.set(0.9);
    }

    // add header text
    this.taskTxt = new G.Text(0, G.OMTsettings.elements.Window_taskSlider.taskTxt.y, `${OMT.language.getText('Task')}:`, G.OMTsettings.elements.Window_taskSlider.taskTxt.style, 0.5, 380);
    this.add(this.taskTxt);

    // if its point based display the points, otherwise display the blocks to collect.
    if (G.lvl.goalMgr.isPointBased()) {
      this.goal = new G.Text(0, G.OMTsettings.elements.Window_taskSlider.taskTxt.y + 62, `${OMT.language.getText('points').toUpperCase()}: ${G.lvl.goalMgr.getPointTarget()}`, G.OMTsettings.elements.Window_taskSlider.goal.style, 0.5, 380);
      this.add(this.goal);
    } else {
      this._taskPanel = G.Helpers.createTaskCollectPanels(G.lvlData.goal[1], true);
      this._taskPanel.y = G.OMTsettings.elements.Window_taskSlider.taskTxt.y + 62;
      this.add(this._taskPanel);
    }

    // tween in
    game.add.tween(this).to({ y: G.l(-120) }, 400, Phaser.Easing.Sinusoidal.Out, true).onComplete.add(() => {
      // wait a second
      game.time.events.add(1000, G.sfx.whoosh_short_2.play, G.sfx.whoosh_short_2);
      // tween out to the bottom of the window
      game.add.tween(this).to({ y: game.height * 1.5 }, 400, Phaser.Easing.Sinusoidal.Out, true, 1000).onComplete.add(function () {
        G.sb('onWindowClosed').dispatch();
        this.destroy();
      }, this);
    }, this);
  }
}
// create global references
if (!window.Windows) window.Windows = {};
Windows.taskSlider = Window_TaskSlider;
